import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLogout } from '@games/api';
import messages from 'intl/messages';
import { useDispatch } from 'react-redux';
import { HelmetTitle } from '../helmet';
import { setAuthUser } from './auth-slice';

export const LogoutPage: React.FC = () => {
  const [, logout] = useLogout();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  React.useEffect(() => {
    logout();
    dispatch(setAuthUser(null));
  }, [logout, dispatch]);

  return (
    <div className='text-center'>
      <HelmetTitle message={formatMessage(messages.logout)} />
      <h2 className='text-2xl mb-4 font-bold'>
        <FormattedMessage {...messages.logout} />
      </h2>
      <div className='mb-4'>
        <FormattedMessage {...messages.loggedOut} />
      </div>
      <div>
        <a
          href='/'
          className='text-lg font-medium text-blue-600 hover:underline'
        >
          <FormattedMessage {...messages.returnToPuzzles} />
        </a>
      </div>
    </div>
  );
};
